export const translations = {
  ko: {
    mainTitle: 'DearX',
    mainSubtitle: '보고싶은 사람이 있나요?',
    scrollHint: '스크롤하여 시작하기',
    formTitle: '누구를 만나고 싶으세요?',
    name: '이름',
    namePlaceholder: '이름을 입력해주세요',
    namePlaceholderAlt: '이름 대신 부르고 싶은 말을 적어도 돼요',
    currentPhoto: '현재 사진',
    uploadCurrentPhoto: '현재 사진 업로드',
    pastPhoto: '그때의 사진',
    uploadPastPhoto: '과거 사진 업로드 (선택)',
    pastPhotoHint: '과거 사진이 있으면 더 정확하게 복원할 수 있어요',
    targetAge: '대화하고 싶은 나이',
    agePlaceholder: '예: 7세, 75세',
    gender: '성별',
    male: '남성',
    female: '여성',
    other_gender: '기타',
    genderSelect: '선택',
    timeDirection: '시간',
    past: '과거',
    future: '미래',
    startChat: '대화 시작하기',
    addMorePeople: '보고 싶은 사람 추가하기',
    managePeople: '대화 상대 관리',
    selectPerson: '누구와 대화하고 싶으신가요?',
    addNewPerson: '만나고 싶은 사람 추가',
    premiumPerson: '프리미엄',
    startConversation: '대화 시작',
    backToMyChat: '내 대화로 돌아가기',
    back: '뒤로',
    self: '나 자신',
    parent: '부모님',
    grandparent: '조부모님',
    sibling: '형제자매',
    friend: '친구',
    other: '기타',
    addPersonTitle: '소중한 사람의 이야기를 들려주세요',
    relationship: '만나고 싶은 사람',
    relationshipPlaceholder: '예: 할머니, 아버지, 친구...',
    characterDetails: '성격과 특징 (선택사항)',
    personality: '성격',
    personalityPlaceholder: '따뜻하고 유머러스한 성격...',
    speechStyle: '말투',
    speechStylePlaceholder: '~했단다, ~하렴 같은 말투...',
    hobbies: '취미',
    hobbiesPlaceholder: '바둑, 낚시, 요리...',
    memories: '함께했던 추억',
    memoriesPlaceholder: '함께 갔던 여행, 특별한 순간들...',
    favoriteWords: '자주 하시던 말',
    favoriteWordsPlaceholder: '걱정하지 마라, 다 잘 될 거야...',
    habits: '습관이나 버릇',
    habitsPlaceholder: '안경을 자주 고쳐 쓰시던 모습...',
    savePerson: '저장하기',
    updatePerson: '수정하기',
    cancel: '취소',
    close: '닫기',
    sendMessage: '메시지를 입력하세요...',
    worryMessage: '만나러가기',
    // 샘플 대화
    samplePerson: '엄마',
    samplePersonDesc: '1985년의 엄마',
    sampleMsg1: '우리 아들 오랜만이야 잘 지냈어?',
    sampleMsg2: '엄마 보고 싶었어',
    sampleMsg3: '나도 보고 싶었어. 밥은 먹었니?',
    sampleMsg4: '엄마가 끓여준 된장찌개 먹고 싶다',
    sampleMsg5: '다음에 또 해줄게 우리 아들 사랑해 ❤️',
    sampleMsg6: '나도 사랑해 엄마 보고싶어 ❤️',
    readyToMeet: '{{year}}년의 {{relationship}}, 만날 준비 됐어요',
    // 캡처/공유
    captureChat: '대화 캡처',
    download: '저장',
    share: '공유',
    captureTagline: '그리움을 만나다',
    careMessage: '그리운 사람의 이야기를 들려주세요',
    loginRequired: '먼저 카카오/구글로 로그인해 주세요.',
    deletePerson: '삭제',
    editPerson: '수정',
    confirmDelete: '정말 삭제하시겠습니까?',
    upgradeRequired: '2명 이상 추가하려면 프리미엄이 필요합니다',
    upgradeToPremium: '프리미엄 업그레이드',
    companyInfo: '회사 소개',
    customerCenter: '고객센터',
    terms: '이용약관',
    privacy: '개인정보처리방침',
    youthProtection: '청소년 보호정책',
    companyName: '(주)디어엑스컴퍼니',
    ceo: '',
    phone: '',
    businessNumber: '사업자등록번호: 등록전',
    address: '',
    copyright: '© 2025 DearX. All rights reserved.',
    login: '로그인',
    loginSubtitle: '소중한 사람과의 대화를 시작하세요',
    continueWithKakao: '카카오로 계속하기',
    continueWithGoogle: 'Google로 계속하기',
    continueWithNaver: '네이버로 계속하기',
    comingSoonMessage: '연동 예정입니다',
    logout: '로그아웃',
    myPage: '마이페이지',
    noPeopleYet: '아직 추가된 사람이 없습니다.',
    requiredFieldsAlert: '필수 정보를 모두 입력해주세요.',
    paymentPage: '결제 페이지로 이동 (구현 예정)',
    pricingTitle: '요금제 선택',
    pricingSubtitle: '소중한 사람과의 대화를 시작하세요',
    priceDay: '하루',
    priceWeek: '1주',
    priceMonth: '1달',
    priceDayAmount: '₩1,900',
    priceDayOriginal: '₩4,900',
    priceWeekAmount: '₩7,900',
    priceWeekOriginal: '₩14,900',
    priceMonthAmount: '₩14,900',
    priceMonthOriginal: '₩29,900',
    priceDayDesc: '24시간 무제한 대화',
    priceWeekDesc: '7일간 무제한 대화',
    priceMonthDesc: '30일간 무제한 대화',
    selectPlan: '선택하기',
    paymentTitle: '결제하기',
    cardNumber: '카드 번호',
    cardNumberPlaceholder: '0000 0000 0000 0000',
    expiryDate: '만료일',
    expiryDatePlaceholder: 'MM/YY',
    cvc: 'CVC',
    cvcPlaceholder: '000',
    cardHolder: '카드 소유자',
    cardHolderPlaceholder: '홍길동',
    payNow: '결제하기',
    securePayment: '안전한 결제',
    paymentProcessing: '결제 처리 중...',
    mostPopular: '인기',
    bestValue: '가성비',
    photoForTime: '사진',
    uploadPhotoDesc: '대화할 시간대의 사진을 업로드해주세요',
    uploadPastPhotoRequired: '과거 사진 업로드',
    uploadFuturePhoto: '미래 모습 사진 업로드',
    freeMessagesUsed: '오늘 무료 대화를 모두 사용했어요',
    freeMessagesInfo: '하루 5회 무료 대화를 모두 사용하셨습니다.',
    addPersonPayTitle: '소중한 사람을 더 만나보세요',
    addPersonPayInfo: '무료 플랜은 1명까지 대화할 수 있어요',
    addPersonPaySub: '프리미엄에서 여러 사람과 대화할 수 있어요',
    freeMessagesRemaining: '오늘 무료 대화 {{count}}회 남음',
    continueWithPremium: '프리미엄으로 계속 대화하세요',
    loginRequiredToContinue: '계속 대화하려면 로그인이 필요해요',
    stepQuestion1: '누구를 만나고 싶으세요?',
    stepQuestion2: '이름을 알려주세요',
    stepQuestion3: '언제의 모습을 만나고 싶으세요?',
    stepQuestion4: '나이와 성별을 알려주세요',
    stepQuestion5: '사진이 있으시면 올려주세요',
    stepQuestion6: '함께한 추억이 있나요?',
    stepHint1: '예: 할머니, 아버지, 친구, 선생님...',
    pastDesc: '그때 그 시절의 모습',
    futureDesc: '미래의 모습',
    photoOptional: '선택사항이에요',
    removePhoto: '사진 삭제',
    next: '다음',
    skip: '건너뛰기',
    readyToMeetSimple: '이제 만나볼 준비가 됐어요',
    genderQuestion: '성별을 알려주세요',
    editMessage: '정보를 수정해주세요',
    sampleConversationTitle: '그리운 누군가를 만날 수 있어요',
    welcomeMessage: '환영합니다!',
    howToCallYou: '어떻게 불러드릴까요?',
    enterYourName: '이름을 입력해주세요',
    startButton: '시작하기',
    dashboardGreeting: '안녕하세요, {{name}}님',
    dashboardSubtitle: '누구와 대화하고 싶으세요?',
    ageUnit: '세',
    // Guest notice
    guestNotice: '로그인하면 대화가 저장돼요',
    guestNoticeLogin: '더 자연스러운 대화가 가능합니다',
    // MyPage
    profileTab: '내 정보',
    subscriptionTab: '구독 관리',
    email: '이메일',
    premiumActive: '프리미엄 이용중',
    freePlan: '무료 플랜',
    extendSubscription: '구독 연장하기',
    cancelSubscription: '구독 해지',
    paymentHistory: '결제 내역',
    noPaymentHistory: '결제 내역이 없습니다',
  },
  en: {
    mainTitle: 'DearX',
    mainSubtitle: 'Is there someone you miss?',
    scrollHint: 'Scroll to start',
    formTitle: 'Who would you like to meet?',
    name: 'Name',
    namePlaceholder: 'Enter your name',
    namePlaceholderAlt: 'You can write what you want to call them',
    currentPhoto: 'Current Photo',
    uploadCurrentPhoto: 'Upload Current Photo',
    pastPhoto: 'Photo from that time',
    uploadPastPhoto: 'Upload Past Photo (Optional)',
    pastPhotoHint: 'A past photo helps restore more accurately',
    targetAge: 'Age you want to talk to',
    agePlaceholder: 'e.g., 7, 75',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    other_gender: 'Other',
    genderSelect: 'Select',
    timeDirection: 'Time',
    past: 'Past',
    future: 'Future',
    startChat: 'Start Chat',
    addMorePeople: 'Add Someone You Miss',
    managePeople: 'Manage Contacts',
    selectPerson: 'Who would you like to talk to?',
    addNewPerson: 'Add Someone You Miss',
    premiumPerson: 'Premium',
    startConversation: 'Start Conversation',
    backToMyChat: 'Back to My Chat',
    back: 'Back',
    self: 'Myself',
    parent: 'Parent',
    grandparent: 'Grandparent',
    sibling: 'Sibling',
    friend: 'Friend',
    other: 'Other',
    addPersonTitle: 'Tell us about someone precious',
    relationship: 'Person you want to meet',
    relationshipPlaceholder: 'e.g., Grandmother, Father, Friend...',
    characterDetails: 'Personality & Traits (Optional)',
    personality: 'Personality',
    personalityPlaceholder: 'Warm and humorous...',
    speechStyle: 'Speech Style',
    speechStylePlaceholder: 'Typical phrases they use...',
    hobbies: 'Hobbies',
    hobbiesPlaceholder: 'Chess, fishing, cooking...',
    memories: 'Shared Memories',
    memoriesPlaceholder: 'Trips together, special moments...',
    favoriteWords: 'Favorite Sayings',
    favoriteWordsPlaceholder: "Don't worry, everything will be fine...",
    habits: 'Habits',
    habitsPlaceholder: 'Often adjusting glasses...',
    savePerson: 'Save',
    updatePerson: 'Update',
    cancel: 'Cancel',
    close: 'Close',
    sendMessage: 'Type a message...',
    worryMessage: "Go meet them",
    // Sample conversation
    samplePerson: 'Mom',
    samplePersonDesc: 'Mom in 1985',
    sampleMsg1: "My dear, it's been so long! How have you been?",
    sampleMsg2: "I missed you, mom",
    sampleMsg3: "I missed you too. Have you eaten?",
    sampleMsg4: "Yeah, I want to eat your homemade stew",
    sampleMsg5: "I'll make it for you next time. Love you ❤️",
    sampleMsg6: "Love you too mom, I miss you ❤️",
    readyToMeet: "Ready to meet {{relationship}} from {{year}}",
    // Capture/Share
    captureChat: 'Capture Chat',
    download: 'Save',
    share: 'Share',
    captureTagline: 'Meet Your Longing',
    careMessage: "Tell us about someone you miss",
    loginRequired: 'Please login with Kakao/Google first.',
    deletePerson: 'Delete',
    editPerson: 'Edit',
    confirmDelete: 'Are you sure you want to delete?',
    upgradeRequired: 'Premium required to add more than 1 person',
    upgradeToPremium: 'Upgrade to Premium',
    companyInfo: 'About Us',
    customerCenter: 'Customer Service',
    terms: 'Terms of Service',
    privacy: 'Privacy Policy',
    youthProtection: 'Youth Protection',
    companyName: 'DearX Company Inc.',
    ceo: '',
    phone: '',
    businessNumber: 'Business No: Pending',
    address: '',
    copyright: '© 2025 DearX. All rights reserved.',
    login: 'Login',
    loginSubtitle: 'Start a conversation with someone precious',
    continueWithKakao: 'Continue with Kakao',
    continueWithGoogle: 'Continue with Google',
    continueWithNaver: 'Continue with Naver',
    comingSoonMessage: 'Coming soon',
    logout: 'Logout',
    myPage: 'My Page',
    noPeopleYet: 'No people added yet.',
    requiredFieldsAlert: 'Please fill in all required fields.',
    paymentPage: 'Redirecting to payment (Coming soon)',
    pricingTitle: 'Choose a Plan',
    pricingSubtitle: 'Start conversations with someone precious',
    priceDay: '1 Day',
    priceWeek: '1 Week',
    priceMonth: '1 Month',
    priceDayAmount: '$1.49',
    priceDayOriginal: '$3.99',
    priceWeekAmount: '$5.99',
    priceWeekOriginal: '$11.99',
    priceMonthAmount: '$11.99',
    priceMonthOriginal: '$24.99',
    priceDayDesc: 'Unlimited conversations for 24 hours',
    priceWeekDesc: 'Unlimited conversations for 7 days',
    priceMonthDesc: 'Unlimited conversations for 30 days',
    selectPlan: 'Select',
    paymentTitle: 'Payment',
    cardNumber: 'Card Number',
    cardNumberPlaceholder: '0000 0000 0000 0000',
    expiryDate: 'Expiry',
    expiryDatePlaceholder: 'MM/YY',
    cvc: 'CVC',
    cvcPlaceholder: '000',
    cardHolder: 'Card Holder',
    cardHolderPlaceholder: 'John Doe',
    payNow: 'Pay Now',
    securePayment: 'Secure Payment',
    paymentProcessing: 'Processing...',
    mostPopular: 'Popular',
    bestValue: 'Best Value',
    photoForTime: 'Photo',
    uploadPhotoDesc: 'Upload a photo from that time period',
    uploadPastPhotoRequired: 'Upload Past Photo',
    uploadFuturePhoto: 'Upload Future Photo',
    freeMessagesUsed: "You've used all free messages today",
    freeMessagesInfo: 'You have used all 5 daily free messages.',
    addPersonPayTitle: 'Meet more loved ones',
    addPersonPayInfo: 'Free plan allows 1 person only',
    addPersonPaySub: 'Talk with more people on Premium',
    freeMessagesRemaining: '{{count}} free messages left today',
    continueWithPremium: 'Continue with Premium',
    loginRequiredToContinue: 'Please login to continue chatting',
    stepQuestion1: 'Who would you like to meet?',
    stepQuestion2: 'What is their name?',
    stepQuestion3: 'When would you like to meet them?',
    stepQuestion4: 'Age and gender',
    stepQuestion5: 'Upload a photo if you have one',
    stepQuestion6: 'Any memories or things you remember?',
    stepHint1: 'e.g., Grandmother, Father, Friend, Teacher...',
    pastDesc: 'From the past',
    futureDesc: 'In the future',
    photoOptional: 'Optional',
    removePhoto: 'Remove photo',
    next: 'Next',
    skip: 'Skip',
    readyToMeetSimple: "Ready to meet them",
    genderQuestion: 'What is their gender?',
    editMessage: 'Edit the information',
    sampleConversationTitle: 'You can meet someone you miss',
    welcomeMessage: 'Welcome!',
    howToCallYou: 'What should we call you?',
    enterYourName: 'Enter your name',
    startButton: 'Get Started',
    dashboardGreeting: 'Hello, {{name}}',
    dashboardSubtitle: 'Who would you like to talk to?',
    ageUnit: ' years old',
    // Guest notice
    guestNotice: 'Conversation may not be accurate as your info is not saved',
    guestNoticeLogin: 'Log in for a more personalized experience',
    // MyPage
    profileTab: 'Profile',
    subscriptionTab: 'Subscription',
    email: 'Email',
    premiumActive: 'Premium Active',
    freePlan: 'Free Plan',
    extendSubscription: 'Extend Subscription',
    cancelSubscription: 'Cancel Subscription',
    paymentHistory: 'Payment History',
    noPaymentHistory: 'No payment history',
  },
  ja: {
    mainTitle: 'DearX',
    mainSubtitle: '会いたい人がいますか？',
    scrollHint: 'スクロールして開始',
    formTitle: '誰に会いたいですか？',
    name: '名前',
    namePlaceholder: '名前を入力してください',
    namePlaceholderAlt: '名前の代わりに呼びたい言葉でもいいですよ',
    currentPhoto: '現在の写真',
    uploadCurrentPhoto: '現在の写真をアップロード',
    pastPhoto: 'その頃の写真',
    uploadPastPhoto: '過去の写真をアップロード（任意）',
    pastPhotoHint: '過去の写真があればより正確に復元できます',
    targetAge: '話したい年齢',
    agePlaceholder: '例：7歳、75歳',
    gender: '性別',
    male: '男性',
    female: '女性',
    other_gender: 'その他',
    genderSelect: '選択',
    timeDirection: '時間',
    past: '過去',
    future: '未来',
    startChat: '会話を始める',
    addMorePeople: '会いたい人を追加',
    managePeople: '連絡先管理',
    selectPerson: '誰と話したいですか？',
    addNewPerson: '会いたい人を追加',
    premiumPerson: 'プレミアム',
    startConversation: '会話を始める',
    backToMyChat: '自分の会話に戻る',
    back: '戻る',
    self: '自分自身',
    parent: '両親',
    grandparent: '祖父母',
    sibling: '兄弟姉妹',
    friend: '友達',
    other: 'その他',
    addPersonTitle: '大切な人について教えてください',
    relationship: '会いたい人',
    relationshipPlaceholder: '例：祖母、父、友達...',
    characterDetails: '性格と特徴（任意）',
    personality: '性格',
    personalityPlaceholder: '温かくてユーモラスな性格...',
    speechStyle: '話し方',
    speechStylePlaceholder: '～だよ、～してね のような話し方...',
    hobbies: '趣味',
    hobbiesPlaceholder: '囲碁、釣り、料理...',
    memories: '一緒の思い出',
    memoriesPlaceholder: '一緒に行った旅行、特別な瞬間...',
    favoriteWords: 'よく言っていた言葉',
    favoriteWordsPlaceholder: '心配するな、大丈夫だよ...',
    habits: '習慣や癖',
    habitsPlaceholder: 'よく眼鏡を直す仕草...',
    savePerson: '保存',
    updatePerson: '更新',
    cancel: 'キャンセル',
    close: '閉じる',
    sendMessage: 'メッセージを入力...',
    worryMessage: '会いに行く',
    // サンプル会話
    samplePerson: 'お母さん',
    samplePersonDesc: '1985年のお母さん',
    sampleMsg1: '久しぶりね、元気だった？',
    sampleMsg2: 'お母さんに会いたかった',
    sampleMsg3: '私も会いたかったよ。ご飯食べた？',
    sampleMsg4: 'うん、お母さんの味噌汁が食べたいな',
    sampleMsg5: '今度また作ってあげるね。愛してるよ ❤️',
    sampleMsg6: '私も愛してる、お母さん会いたい ❤️',
    readyToMeet: '{{year}}年の{{relationship}}に会う準備ができました',
    // キャプチャ/共有
    captureChat: '会話をキャプチャ',
    download: '保存',
    share: '共有',
    captureTagline: '懐かしさに会う',
    careMessage: '懐かしい人のことを教えてください',
    loginRequired: 'まずカカオ/Googleでログインしてください。',
    deletePerson: '削除',
    editPerson: '編集',
    confirmDelete: '本当に削除しますか？',
    upgradeRequired: '2人以上追加するにはプレミアムが必要です',
    upgradeToPremium: 'プレミアムにアップグレード',
    companyInfo: '会社概要',
    customerCenter: 'カスタマーサービス',
    terms: '利用規約',
    privacy: 'プライバシーポリシー',
    youthProtection: '青少年保護方針',
    companyName: '株式会社ディアエックス',
    ceo: '',
    phone: '',
    businessNumber: '事業者登録番号：登録前',
    address: '',
    copyright: '© 2025 DearX. All rights reserved.',
    login: 'ログイン',
    loginSubtitle: '大切な人との会話を始めましょう',
    continueWithKakao: 'カカオで続ける',
    continueWithGoogle: 'Googleで続ける',
    continueWithNaver: 'NAVERで続ける',
    comingSoonMessage: '近日公開予定です',
    logout: 'ログアウト',
    myPage: 'マイページ',
    noPeopleYet: 'まだ追加された人がいません。',
    requiredFieldsAlert: '必須項目をすべて入力してください。',
    paymentPage: '決済ページへ移動（準備中）',
    pricingTitle: 'プランを選択',
    pricingSubtitle: '大切な人との会話を始めましょう',
    priceDay: '1日',
    priceWeek: '1週間',
    priceMonth: '1ヶ月',
    priceDayAmount: '¥200',
    priceDayOriginal: '¥500',
    priceWeekAmount: '¥850',
    priceWeekOriginal: '¥1,700',
    priceMonthAmount: '¥1,600',
    priceMonthOriginal: '¥3,300',
    priceDayDesc: '24時間無制限会話',
    priceWeekDesc: '7日間無制限会話',
    priceMonthDesc: '30日間無制限会話',
    selectPlan: '選択',
    paymentTitle: 'お支払い',
    cardNumber: 'カード番号',
    cardNumberPlaceholder: '0000 0000 0000 0000',
    expiryDate: '有効期限',
    expiryDatePlaceholder: 'MM/YY',
    cvc: 'CVC',
    cvcPlaceholder: '000',
    cardHolder: 'カード名義',
    cardHolderPlaceholder: '山田太郎',
    payNow: '支払う',
    securePayment: '安全な決済',
    paymentProcessing: '処理中...',
    mostPopular: '人気',
    bestValue: 'お得',
    photoForTime: '写真',
    uploadPhotoDesc: 'その時期の写真をアップロードしてください',
    uploadPastPhotoRequired: '過去の写真をアップロード',
    uploadFuturePhoto: '未来の写真をアップロード',
    freeMessagesUsed: '今日の無料会話を使い切りました',
    freeMessagesInfo: '1日5回の無料会話をすべて使用しました。',
    addPersonPayTitle: '大切な人にもっと会いましょう',
    addPersonPayInfo: '無料プランは1人まで会話できます',
    addPersonPaySub: 'プレミアムで複数の人と会話できます',
    freeMessagesRemaining: '今日の無料会話 残り{{count}}回',
    continueWithPremium: 'プレミアムで会話を続ける',
    loginRequiredToContinue: '会話を続けるにはログインが必要です',
    stepQuestion1: '誰に会いたいですか？',
    stepQuestion2: '名前を教えてください',
    stepQuestion3: 'いつの姿に会いたいですか？',
    stepQuestion4: '年齢と性別',
    stepQuestion5: '写真があればアップロードしてください',
    stepQuestion6: '一緒の思い出や覚えていることはありますか？',
    stepHint1: '例：祖母、父、友達、先生...',
    pastDesc: '過去の姿',
    futureDesc: '未来の姿',
    photoOptional: '任意です',
    removePhoto: '写真を削除',
    next: '次へ',
    skip: 'スキップ',
    readyToMeetSimple: '会う準備ができました',
    genderQuestion: '性別を教えてください',
    editMessage: '情報を編集してください',
    sampleConversationTitle: '懐かしい誰かに会えます',
    welcomeMessage: 'ようこそ！',
    howToCallYou: 'なんとお呼びしましょうか？',
    enterYourName: '名前を入力してください',
    startButton: '始める',
    dashboardGreeting: 'こんにちは、{{name}}さん',
    dashboardSubtitle: '誰と話したいですか？',
    ageUnit: '歳',
    // Guest notice
    guestNotice: '会員情報が保存されていないため、会話内容が正確でない場合があります',
    guestNoticeLogin: 'ログインするとより自然な会話ができます',
    // MyPage
    profileTab: 'プロフィール',
    subscriptionTab: '購読管理',
    email: 'メール',
    premiumActive: 'プレミアム利用中',
    freePlan: '無料プラン',
    extendSubscription: '購読を延長',
    cancelSubscription: '購読解除',
    paymentHistory: 'お支払い履歴',
    noPaymentHistory: 'お支払い履歴がありません',
  },
};

export default translations;
